<app-error *ngIf="error" [message]="error"></app-error>

<div class="factory-container">
  <div *ngIf="!isCreateMode">
    <app-con-x-table-page
      eyebrow="Construct-X"
      eyebrowIcon="description"
      title="SD Factory"
      description="Gespeicherte Self-Descriptions durchsuchen, prüfen und herunterladen."
      ariaLabel="Self-Descriptions"
      locale="de-DE"
      [data]="savedSds"
      [columns]="savedSdColumns"
      [actions]="pageActions"
      [rowActions]="savedSdActions"
      [inspector]="savedSdInspector"
      [summaryItems]="summaryItems"
      [emptyState]="savedSdEmptyState"
      [loading]="savedSdsLoading"
      loadingMessage="Self-Descriptions werden geladen …"
      [errorMessage]="savedSdsError"
      errorTitle="SD Factory nicht erreichbar"
      searchPlaceholder="Name oder Beschreibung suchen"
      noResultsTitle="Keine passenden Self-Descriptions"
      noResultsDescription="Ändern Sie den Suchbegriff."
      [refreshable]="false"
      [pageSize]="10"
      [pageSizeOptions]="[10, 25, 50]"
      (pageAction)="handlePageAction($event)"
      (rowAction)="handleSavedSdAction($event)">
    </app-con-x-table-page>
  </div>

  <section class="factory-section create-section" *ngIf="isCreateMode">
    <div class="creation-header">
      <div>
        <span>SD Factory</span>
        <h2>Neue SD erstellen</h2>
      </div>
      <button mat-button color="primary" (click)="isCreateMode = false">
        <mat-icon>arrow_back</mat-icon>
        Übersicht
      </button>
    </div>

    <div class="selection-area" *ngIf="isCreateMode">
      <mat-form-field appearance="outline" class="shape-select">
        <mat-label>Wählen Sie ein Shape</mat-label>
        <mat-select [value]="selectedIri" [disabled]="shapesLoading"
          (openedChange)="onShapeDropdownOpened($event)" (selectionChange)="onShapeSelected($event.value)">
          <mat-option *ngFor="let s of shapes; trackBy: trackByIri" [value]="s.targetClass">
            {{ s.name }}
          </mat-option>
          <mat-option *ngIf="!shapesLoading && !shapes.length" disabled>Keine Shapes verfügbar</mat-option>
        </mat-select>
        <mat-spinner *ngIf="shapesLoading" matSuffix diameter="18"></mat-spinner>
      </mat-form-field>
      <div class="shape-load-error" *ngIf="shapesError" role="alert">
        <span>{{ shapesError }}</span>
        <button mat-button color="primary" type="button" (click)="loadShapes()" [disabled]="shapesLoading">
          Erneut versuchen
        </button>
      </div>
    </div>

    <div class="detail" *ngIf="selectedIri">
      <ng-container *ngIf="!createShapeForm; else createShapeFormTpl">
        <ng-container *ngIf="!detailLoading; else loadingTpl">
          <div *ngIf="!detailError" class="json-viewer">
            <div class="detail-header">
              <div class="meta">
                <h4 *ngIf="selectedName">{{ selectedName }}</h4>
                <p *ngIf="selectedDescription">{{ selectedDescription }}</p>
              </div>
              <button mat-raised-button color="primary" (click)="createForm()" [disabled]="!detailJson"
                *ngIf="isCreateMode">
                Formular erstellen
              </button>
            </div>
            <div class="json-content"><pre>{{ detailJson | json }}</pre></div>
          </div>
        </ng-container>

        <ng-template #loadingTpl>
          <div class="loading-container">
            <mat-spinner diameter="40"></mat-spinner>
            <span>Shape-Details werden geladen …</span>
          </div>
        </ng-template>
      </ng-container>

      <ng-template #createShapeFormTpl>
        <div class="form-container">
          <app-form (close)="createShapeForm = false" (formValue)="emitFormValue($event)"></app-form>
        </div>
      </ng-template>

      <div *ngIf="detailError" class="error-msg">{{ detailError }}</div>
    </div>
  </section>
</div>

<ng-template #sdDocumentDialog>
  <section class="sd-document-dialog" aria-labelledby="sd-document-dialog-title">
    <header class="sd-document-dialog-header">
      <span class="sd-document-dialog-icon"><mat-icon>description</mat-icon></span>
      <div>
        <span>Self-Description</span>
        <h2 id="sd-document-dialog-title">{{ dialogSd?.name || 'SD-Dokument' }}</h2>
        <p>
          <span>SD {{ dialogSd?.id }}</span>
          <span *ngIf="dialogSd?.createdAt">{{ dialogSd?.createdAt | date:'medium' }}</span>
        </p>
      </div>
      <button mat-icon-button mat-dialog-close type="button" aria-label="SD-Dokument schließen">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <mat-dialog-content class="sd-document-dialog-content">
      <p class="sd-document-description" *ngIf="dialogSd?.description">{{ dialogSd?.description }}</p>
      <div class="sd-document-json"><pre>{{ dialogJson }}</pre></div>
    </mat-dialog-content>

    <mat-dialog-actions class="sd-document-dialog-actions" align="end">
      <button mat-stroked-button color="primary" type="button" [disabled]="!dialogJson" (click)="copyOpenSd()">
        <mat-icon>{{ sdCopied ? 'check' : 'content_copy' }}</mat-icon>
        {{ sdCopied ? 'Kopiert' : 'JSON kopieren' }}
      </button>
      <button mat-stroked-button color="primary" type="button" [disabled]="!dialogJson" (click)="downloadOpenSd()">
        <mat-icon>download</mat-icon>
        Herunterladen
      </button>
      <button mat-flat-button color="primary" mat-dialog-close type="button">Schließen</button>
    </mat-dialog-actions>
  </section>
</ng-template>
